module.exports = __webpack_public_path__ + "img/qltb.fb32029f.svg";